class ScheduledSection extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  /**
   * Normalize "YYYY-MM-DD HH:MM" to "YYYY-MM-DDTHH:MM" so Date.parse() treats it as local time
   * and works consistently in all browsers (Safari requires ISO-style format).
   */
  parseDateString(value) {
    if (!value || typeof value !== 'string') return NaN;
    const normalized = value.trim().replace(/\s+/, 'T');
    return Date.parse(normalized);
  }

  connectedCallback() {
    const hasEnd = this.hasAttribute('data-end');
    const hasStart = this.hasAttribute('data-start');

    if (!hasEnd && !hasStart) return;

    if (hasEnd) {
      const endDateString = this.dataset.end;
      const parsedEnd = this.parseDateString(endDateString);
      if (isNaN(parsedEnd)) {
        console.warn('Invalid end date format:', endDateString);
      } else {
        this.end = Math.floor(parsedEnd / 1000);
      }
    }

    if (hasStart) {
      const startDateString = this.dataset.start;
      const parsedStart = this.parseDateString(startDateString);
      if (isNaN(parsedStart)) {
        console.warn('Invalid start date format:', startDateString);
      } else {
        this.start = Math.floor(parsedStart / 1000);
      }
    }

    this.checkVisibility();
    this.startWatcher();
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  getCurrentTime() {
    return Math.floor(Date.now() / 1000);
  }

  checkVisibility() {
    const now = this.getCurrentTime();

    if (this.start != null && now < this.start) {
      this.hide();
      return;
    }
    if (this.end != null && now > this.end) {
      this.hide();
      return;
    }
    this.show();
  }

  hide() {
    this.style.display = "none";
  }

  show() {
    this.style.display = "";
  }

  startWatcher() {
    this.interval = setInterval(() => {
      this.checkVisibility();
    }, 1000);
  }
}

customElements.define('scheduled-section', ScheduledSection);